import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HelpService {

  private showButton = signal<boolean>(false);

  constructor() { }

  show() {
    this.showButton.set(true);
  }

  hide() {
    this.showButton.set(false);
  }

  getStateButtonHelp() {
    return this.showButton.asReadonly();
  }
}
